import React, { useMemo, useState } from "react";
import { caseStatus, LABEL_WIDTH, reportStatusLabel } from "../../../constants";
import CaseStatusCell from "../../../components/Table/Project/TestScheduleTableInfo/CaseStatusCell";
import InputInForm from "../../../components/UI/Form/Input/InputInForm";
import InputDate from "../../../components/UI/Form/Input/InputDate";
import PrimaryBtn from "../../../components/UI/Button/PrimaryBtn";
import { Box, Modal, useMediaQuery } from "@mui/material";
import InputText from "../../../components/UI/Form/Input/InputText";
import SelectCustomerPic from "../../../components/UI/Form/Select/SelectCustomerPic";
import InvoiceItemInfosTable from "../CreateAndUpdatePage/InvoiceItemInfosTable";

const Item = ({ data, index, formik, initInvoices, handleChangeCreateInvoiceInfo }) => {
  const isMd = useMediaQuery("(max-width:768px)");
  const { values, setFieldValue } = formik;

  const [selectConfirmId, setSelectConfirmId] = useState(null);
  const [errors, setErrors] = useState({});

  const cellStyle = `flex items-center justify-center p-2 overflow-hidden whitespace-nowrap border border-[#B3B3B3]`;

  const disableChangeStatus = useMemo(() => {
    return data.caseStatus === caseStatus.lost || data.caseStatus === caseStatus.completed;
  }, [data.caseStatus]);

  return (
    <React.Fragment>
      <div className={"border-l " + cellStyle}>{data.caseId}</div>
      <div className={cellStyle}>
        {reportStatusLabel[data.invoiceStatus]}
      </div>
      <div className={cellStyle}>
        {data?.customer?.customerId || ""}
      </div>
      <InputDate
        id="paymentDeadline"
        value={values?.[index]?.paymentDeadline}
        onChange={(newValue) => {
          setFieldValue(`${index}.paymentDeadline`, newValue);
        }}
        isFormStyle
      />
      <InputInForm
        value={values?.[index]?.memo}
        className={cellStyle}
        onChange={(newValue) => {
          setFieldValue(`${index}.memo`, newValue);
        }}
      />
      <div className={cellStyle}>
        {values?.[index]?.isConfirmed ? (
          <>
            <button
              type={'button'}
              onClick={() => setSelectConfirmId(data.caseId)}
              className="text-[#1976d2] text-[0.8125em] underline"
            >確認済</button>

            <Modal
              open={selectConfirmId === data.caseId}
              onClose={() => {
                // resetModal();
                setSelectConfirmId(null);
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: "360px",
                  bgcolor: "white",
                  boxShadow: 24,
                  p: 4,
                  borderRadius: 2,
                }}
                className="bg-white"
              >
                <div className="mb-6">
                  確認済のステータスを解除しますか？
                </div>

                <div className="w-full h-auto flex items-center justify-end gap-2 flex-wrap">
                  <PrimaryBtn
                    text={'はい'}
                    onClick={() => {
                      setSelectConfirmId(null)
                      setFieldValue(`${index}.isConfirmed`, false)
                    }}
                  />
                  <PrimaryBtn
                    text={'いいえ'}
                    onClick={() => {
                      setSelectConfirmId(null)
                    }}
                  />
                </div>
              </Box>
            </Modal>
          </>
        ) : (
          <>
            <PrimaryBtn
              text="確認へ"
              onClick={() => {
                setSelectConfirmId(data.caseId)
              }}
              className="!h-[30px]"
              disabled={disableChangeStatus}
            />

            <Modal
              open={selectConfirmId === data.caseId}
              onClose={() => {
                setErrors({})
                setSelectConfirmId(null);
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: isMd ? "90%" : "75%",
                  bgcolor: "white",
                  boxShadow: 24,
                  p: isMd ? 2 : 4,
                  borderRadius: 2,
                  maxHeight: "600px",
                  overflow: "auto",
                }}
                className="bg-white"
              >
                <div className="flex items-center gap-4 mb-6">
                  <p>見積番号</p>
                  <p>{data.quotationInfo?.quotationId || ''}</p>
                </div>

                <div className="w-full h-auto flex items-center justify-center mb-4 flex-wrap">
                  <div className="w-full mb-3 md:mb-0 md:w-1/2 h-full">
                    <InputDate
                      id="paymentDeadline"
                      value={values?.[index]?.paymentDeadline}
                      onChange={(newValue) => {
                        setFieldValue(`${index}.paymentDeadline`, newValue);
                      }}
                      label="振込期限"
                      isRequired
                      errors={errors.paymentDeadlineError}
                      touched={true}
                      labelWidth={LABEL_WIDTH.LEFT}
                      isShowError={true}
                    />
                  </div>

                  <div className="w-full mb-3 md:w-1/2 h-full">
                    <SelectCustomerPic
                      pic={{id: initInvoices?.[index]?.customerPic}}
                      labelWidth={LABEL_WIDTH.LEFT}
                      disabled={true}
                    />
                  </div>
                </div>

                <div className="w-full h-auto flex items-center justify-center mb-3 flex-wrap">
                  <div className="w-full mb-3 md:mb-0 h-full">
                    <InputText
                      value={values?.[index]?.memo}
                      onChange={(newValue) => {
                        setFieldValue(`${index}.memo`, newValue)
                      }}
                      label="備考"
                      labelWidth={LABEL_WIDTH.LEFT}
                    />
                  </div>
                </div>

                <div className="mb-[14px]">
                  <InvoiceItemInfosTable
                    invoiceItemInfos={initInvoices?.[index]?.invoiceItemInfos}
                    setInvoiceItemInfos={(newValue) => {
                      handleChangeCreateInvoiceInfo(index, newValue);
                    }}
                  />
                </div>

                <div className="w-full h-auto flex items-center justify-end gap-2 mb-3 flex-wrap">
                  <PrimaryBtn
                    text={'確認する'}
                    onClick={() => {
                      if (values?.[index]?.paymentDeadline && /^\d{4}-\d{2}-\d{2}$/.test(values?.[index]?.paymentDeadline)) {
                        setSelectConfirmId(null)
                        setFieldValue(`${index}.isConfirmed`, true)
                        setErrors({ paymentDeadlineError: false })
                      } else {
                        setErrors({ paymentDeadlineError: true })
                      }
                    }}
                  />
                  <PrimaryBtn
                    text={'キャンセル'}
                    onClick={() => {
                      setSelectConfirmId(null)
                      setErrors({})
                    }}
                  />
                </div>
              </Box>
            </Modal>
          </>
          )}
      </div>

      <CaseStatusCell
        cellContent={data.caseStatus}
        textAlign="center"
      />
    </React.Fragment>
  );
};

export default Item;
